import React from 'react';
import PropTypes from 'prop-types';
import { PharmacistHeader } from '~/shared/components';
import { Wrapper, Footer } from './styles';

const PharmacistLayout = ({ children }) => {
  return (
    <Wrapper>
      <PharmacistHeader />
      {children}
      <Footer>
        Hospital Israelita Albert Einstein | Todos os direitos reservados
      </Footer>
    </Wrapper>
  );
};

PharmacistLayout.propTypes = {
  children: PropTypes.node.isRequired,
};
export default PharmacistLayout;
